<template>
  <div class="second-parent">
    <div class="img-container">
      <transition-block name="fade" mode="out-in">
        <img style="max-width: 162px; height: auto;" :key="onboard.indexOf(currentElement())"
             :src="currentElement().image">
      </transition-block>
    </div>
    <div class="main-container rounded-t-3xl wrap flex-1 flex flex-col space-between auth">
      <transition-block name="fade" mode="out-in">
        <div :key="onboard.indexOf(currentElement())">
          <h1 class="mb-6 text-align-center">{{ currentElement().title }}</h1>
          <div class="text-left" v-if="currentElement().id === 1">
            <div v-if="currentElement().video">
              <div class="container-embed" v-html="video"></div>
              <div style="var(--transition-quick)"
                   class=" flex mt-2 mr-4 justify-between items-end arrow-full-screen">

                <p class="small italic">{{ $t('capsule.solutionVideo.helpParent') }}</p>
                <svg width="48" viewBox="0 0 92 76" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M66.7417 27.5052L68.2279 27.7081L68.2279 27.7081L66.7417 27.5052ZM66.9255 26.1587L68.4118 26.3617L68.4173 26.321L68.4206 26.2801L66.9255 26.1587ZM65.8223 8.28689L64.3535 8.59121L64.3535 8.59121L65.8223 8.28689ZM66.0263 4.04391C65.3339 3.58915 64.4039 3.78184 63.9491 4.47429L56.5384 15.7584C56.0837 16.4509 56.2764 17.3809 56.9688 17.8356C57.6613 18.2904 58.5913 18.0977 59.046 17.4052L65.6333 7.37491L75.6637 13.9622C76.3561 14.417 77.2861 14.2243 77.7409 13.5318C78.1956 12.8394 78.0029 11.9094 77.3105 11.4546L66.0263 4.04391ZM62.0709 45.2208L60.6742 44.6739L60.6742 44.6739L62.0709 45.2208ZM63.6165 41.2734L65.0133 41.8203L65.0304 41.7766L65.0447 41.7319L63.6165 41.2734ZM48.0627 62.4522L47.2942 61.164L47.2942 61.164L48.0627 62.4522ZM48.3323 62.2913L49.1007 63.5795L49.1889 63.527L49.269 63.4629L48.3323 62.2913ZM51.1703 60.0223L50.2336 58.8507L50.2336 58.8507L51.1703 60.0223ZM23.9644 70.2489L24.1911 71.7316L24.1911 71.7316L23.9644 70.2489ZM31.7926 68.7302L31.4484 67.2702L31.4484 67.2702L31.7926 68.7302ZM34.3055 68.1378L34.6496 69.5978L34.6602 69.5953L34.6707 69.5927L34.3055 68.1378ZM58.6726 51.7895L57.4193 50.9654L57.4193 50.9654L58.6726 51.7895ZM68.2279 27.7081L68.4118 26.3617L65.4393 25.9558L65.2555 27.3022L68.2279 27.7081ZM67.2911 7.98256L66.6717 4.99338L63.7341 5.60203L64.3535 8.59121L67.2911 7.98256ZM63.4677 45.7677L65.0133 41.8203L62.2198 40.7265L60.6742 44.6739L63.4677 45.7677ZM48.8311 63.7404L49.1007 63.5795L47.5639 61.0031L47.2942 61.164L48.8311 63.7404ZM49.269 63.4629L52.107 61.1939L50.2336 58.8507L47.3956 61.1197L49.269 63.4629ZM16.6149 72.89L24.1911 71.7316L23.7377 68.7661L16.1615 69.9245L16.6149 72.89ZM32.1367 70.1902L34.6496 69.5978L33.9613 66.6779L31.4484 67.2702L32.1367 70.1902ZM24.1911 71.7316C26.8596 71.3236 29.5093 70.8095 32.1367 70.1902L31.4484 67.2702C28.8986 67.8713 26.3272 68.3701 23.7377 68.7661L24.1911 71.7316ZM47.2942 61.164C43.1356 63.6446 38.6367 65.5039 33.9402 66.683L34.6707 69.5927C39.6508 68.3424 44.4214 66.3708 48.8311 63.7404L47.2942 61.164ZM57.4193 50.9654C55.4534 53.9551 53.0284 56.6163 50.2336 58.8507L52.107 61.1939C55.1481 58.7625 57.7868 55.8669 59.9259 52.6136L57.4193 50.9654ZM68.4206 26.2801C68.9175 20.1583 68.5372 13.9968 67.2911 7.98256L64.3535 8.59121C65.5416 14.3256 65.9043 20.2004 65.4305 26.0374L68.4206 26.2801ZM59.9259 52.6136C61.3414 50.461 62.5284 48.1666 63.4677 45.7677L60.6742 44.6739C59.811 46.8785 58.7201 48.9871 57.4193 50.9654L59.9259 52.6136ZM65.0447 41.7319C66.5129 37.1591 67.578 32.4666 68.2279 27.7081L65.2555 27.3022C64.6293 31.8872 63.603 36.4087 62.1883 40.8148L65.0447 41.7319Z"
                      fill="black"/>
                </svg>
              </div>
            </div>
          </div>
          <div v-else-if="currentElement().id === 3">
            <AskNewsletter @handleChange="changeInfos"/>
          </div>
          <div v-else-if="currentElement().id === 2">
            <p>{{ $t('onboard.steps.freeContentText') }}</p>
            <img style="display: block; margin: 0 auto;" src="../../assets/img/onboarding_gift.png" alt="">
          </div>
          <div v-else-if="currentElement().id === 4">
            <handle-subscription />
          </div>
        </div>
      </transition-block>
      <div class="flex flex-col items-center">
        <primary-button v-if="currentElement().id !== onboard.length" @click.native="nextPage">
          {{ $t('capsule.next') }}
        </primary-button>
        <uni-button v-else @click.native="nextPage" appearance="subtle"
                    :label="$t('onboard.steps.action')"/>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/PrimaryButton";
import TransitionBlock from "@/components/TransitionBlock";
import currentFamilyCheck from "@/library/currentFamilyCheck";
import {mapGetters} from 'vuex'
import MD5 from 'crypto-js/md5'
import AskNewsletter from "../../components/Locale/AskNewsletter.vue";
import Storage from "../../../class/storage";
import Help from "@/components/Help";

const storage = new Storage('locale')
import i18n from '../../locales/index'
import UniButton from "@/components/UniButton.vue";
import HandleSubscriptionModal from "@/components/handleSubscriptionModal.vue";
import HandleSubscription from "@/components/handleSubscription.vue";

export default {
  name: "OnBoard",
  components: {
    UniButton,
    HandleSubscription,
    HandleSubscriptionModal,
    Help,
    AskNewsletter,
    TransitionBlock,
    PrimaryButton
  },
  mixins: [currentFamilyCheck],
  computed: {
    ...mapGetters(['currentFamily']),
  },
  data() {
    return {
      onboard: [
        {
          id: 1,
          title: i18n.t('onboard.steps.howItWorks'),
          text: "Chaque semaine, je vous invite à découvrir une nouvelle capsule d’environ 15 minutes.",
          image: require('@/assets/img/onboarding_runningman.png'),
          html: false,
          video: true,
          hidden: false,
          free: false,
          sub: false
        },
        {
          id: 2,
          title: i18n.t('onboard.steps.freeContent'),
          text: "",
          image: require('@/assets/img/passe-a-laction.png'),
          html: true,
          video: false,
          free: true,
          hidden: true,
          sub: false
        },
        {
          id: 3,
          title: i18n.t('onboard.steps.beforeYouStart'),
          text: "",
          image: require('@/assets/img/onboarding_runningman2.png'),
          html: true,
          video: false,
          hidden: true,
          free: false,
          sub: false
        },
        {
          id: 4,
          title: i18n.t('pricing.title'),
          text: "",
          image: require('@/assets/img/onboarding_runningman2.png'),
          html: false,
          video: false,
          hidden: true,
          free: false,
          sub: true
        },

      ],
      current: 0,
      locale: storage.get.locale || "fr",
      newsletter: false,
      video: '',
    }
  },
  created() {
    if (this.currentFamily.isOnboarded()) {
      this.$router.push({name: "Home"})
    }
    const videoId = this.getId(i18n.t('onboard.steps.video'));
    const iframe = '<iframe allowfullscreen="allowfullscreen" src="//www.youtube.com/embed/'
        + videoId + '?rel=0;picture-in-picture=1&amp;accelerometer=1&amp;gyroscope=1&amp;autoplay=0" frameborder="0" style="border-radius: var(--radius-default);\n' +
        '    position: absolute;\n' +
        '    top: 0;\n' +
        '    bottom: 0;\n' +
        '    left: 0;\n' +
        '    width: 100%;\n' +
        '    height: 100%;\n' +
        '    border: 0;" ></iframe>';

    this.video = iframe
  },
  updated() {
  },
  methods: {
    getId(url) {
      if (url.includes('shorts')) {
        let arr = url.split('/')
        let id = arr[arr.length - 1]
        return (id.length === 11)
            ? id
            : null;
      } else {
        let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        let match = url.match(regExp);

        return (match && match[2].length === 11)
            ? match[2]
            : null;
      }

    },
    async nextPage() {
      if (this.current + 1 === this.onboard.length) {
        await this.validate_onboarding()
      } else {
        this.current = this.current + 1
        this.onboard[this.current].hidden = false
        this.onboard[this.current - 1].hidden = true
      }
    },
    currentElement() {
      return this.onboard.find(el => !el.hidden)
    },
    changeInfos(args) {
      this.locale = args.locale
      this.newsletter = args.newsletter
    },
    async validate_onboarding() {
      this.$http.put(`families/${this.currentFamily.id}`, {
        family: {
          locale: this.locale,
          newsletter: this.newsletter
        },
        onboarded: true
      }).then(resp => {
        if (resp.status !== 200) {
          this.$router.push({name: 'Logout'})
          // TODO : error message
        } else {
          localStorage.token = resp.data.auth_token
          this.$store.dispatch('login')

          let aeEvent = {};
          /* {{KEY}} must be updated for each rule */
          aeEvent.key = '61f3bd0566d3891597f0e456-61f3a7a166d3891597f0e3e7';
          aeEvent.Conversion = {};
          /* Values below must be updated */
          aeEvent.Conversion.id = MD5(this.currentFamily.email).toString();
          aeEvent.Conversion.customer = this.currentFamily.id;
          aeEvent.Conversion.currency = 'EUR';
          ('AeTracker' in window)
              ? AeTracker.sendConversion(aeEvent)
              : (window.AE = window.AE || []).push(aeEvent);
          this.$router.push({name: 'Home'})
        }
      }).catch(e => {
        throw e
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 576px) {
  .main-container {
    min-height: 530px;
    flex: none;
  }
}

.img-container {
  height: 180px;
  position: relative;

  img {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
    height: 90%;

  }
}

.second-parent {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

h1 {
  white-space: pre;
}

.bg-primary.current {
  background: linear-gradient(
          180deg, #E62145 0%, #B81230 100%);
}

.bg-primary {
  background: var(--color-surface-strong)
}

.container-embed {
  border-radius: var(--radius-default);
  position: relative;
  height: 215px;
}

@include screen-m {
  .container-embed {
    width: 100%;
    height: 300px;
  }
}

</style>